import * as React from 'react';
import { UIHeading3, UIText2 } from '@cian/ui-kit';

import { IconPlaceholderBuilder16 } from '@cian/ui-kit-design-tokens/icons';

import { Link } from '../../Link';
import { ITurnInfo } from '../../../types/newbuilding';

import { HousesByTurn } from '../components/HousesByTurn';
import * as styles from './NewbuildingInfoMobile.css';

export interface INewbuildingInfoMobileProps {
  builderName?: string;
  favoriteButton: React.ReactNode;
  housesByTurn: ITurnInfo[];
  newbuildingName: string;
  onLinkClick?(): void;
  problemLabel?: React.ReactNode;
  reliableLabel?: React.ReactNode;
  statuses: string[];
  url: string;
}

export const NewbuildingInfoMobile: React.FC<INewbuildingInfoMobileProps> = ({
  builderName,
  favoriteButton,
  housesByTurn,
  newbuildingName,
  onLinkClick,
  reliableLabel,
  problemLabel,
  statuses,
  url,
}) => {
  return (
    <div className={styles['container']} data-testid="NewbuildingInfoMobile">
      <div className={styles['favorite-button']}>{favoriteButton}</div>

      <div className={styles['title']}>
        <UIHeading3 as="h1">
          Ход строительства ЖК «{newbuildingName}»
          <span>
            {reliableLabel}
            {problemLabel}
          </span>
        </UIHeading3>
        <ul className={styles['statuses']}>
          {statuses.map((status, idx) => (
            <li key={idx}>{status}</li>
          ))}
        </ul>
      </div>

      {housesByTurn.length && <HousesByTurn housesByTurn={housesByTurn} />}

      {builderName && (
        <div className={styles['builder']}>
          <span className={styles['builder-icon']}>
            <IconPlaceholderBuilder16 color="icon-positive-default" />
          </span>
          <UIText2 color="text-secondary-default">Застройщик {builderName}</UIText2>
        </div>
      )}

      <div className={styles['link']}>
        <Link href={url} onClick={onLinkClick}>
          Про жилой комплекс
        </Link>
      </div>
    </div>
  );
};
